var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
import CorePanel from "@/prefabs/core/Panel";
import SplashGame from "@/lib/SplashGame";
import UtilsScreen from "@/lib/utils/screen";
var PanelStart = /** @class */ (function (_super) {
    __extends(PanelStart, _super);
    function PanelStart(scene, callback) {
        var _this = this;
        var _a = UtilsScreen.safe_area(scene), x_min = _a.x_min, x_max = _a.x_max, width = _a.width, height = _a.height;
        _this = _super.call(this, scene, width / 2, height / 2) || this;
        var i18nHandler = SplashGame.i18nHandler.getInstance();
        var rectangle = new Phaser.GameObjects.Rectangle(scene, 0, 0, width, height, 0x17171d, 0.7);
        _this.text = new Phaser.GameObjects.Text(scene, 0, 0, i18nHandler.get("panel.start.text"), {
            fontFamily: config.graphics.fontFamily,
        })
            .setFontSize(64)
            .setOrigin(0.5);
        _this.setInteractive(rectangle, function () {
            if (!_this.scene.input.activePointer.isDown) {
                return false; // HitAreaCallback için false döndür
            }
            callback(); // Kullanıcı tanımlı fonksiyonu çağır
            return true; // HitAreaCallback için true döndür
        });
        _this.add(rectangle);
        _this.add(_this.text);
        _this.setDepth(99999999999);
        _this.setScrollFactor(0);
        return _this;
    }
    PanelStart.prototype.resize = function (_width, _height) {
        var s_x = _width / this.text.width;
        var s = Math.min(s_x, 1);
        this.text.setScale(s);
    };
    return PanelStart;
}(CorePanel));
export default PanelStart;
